import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/main.css'

const SearchModal = ({ onClose }) => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [location, setLocation] = useState('Skardu');

  // State to store the list from Database
  const [specialtiesList, setSpecialtiesList] = useState([]);

  // 1. Fetch Specialties from Backend on Load
  useEffect(() => {
    const fetchSpecialties = async () => {
      try {

        const res = await axios.get(process.env.REACT_APP_API_BASE_URL + "/doctors/specialties/list");
        if (res.data.success) {
          setSpecialtiesList(res.data.data);
        }
      } catch (err) {
        console.error("Error fetching specialties", err);
      }
    };
    fetchSpecialties();
  }, []);

  // Filter the list based on user typing
  const filteredSpecialties = specialtiesList.filter(specialty =>
    specialty.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchTerm) {
      // Go to DoctorsPage with Search Query
      navigate(`/doctors?search=${searchTerm}`);
      onClose();
    }
  };

  const handleSelectSpecialty = (specialty) => {

    const cleanUrl = specialty.replace(/ /g, '-').toLowerCase();


    navigate(`/specialty/${cleanUrl}`);
    onClose();
  };

  return (
    <div className="search-modal-overlay" onClick={onClose}>
      <div className="search-modal-content" onClick={(e) => e.stopPropagation()}>

        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="modal-title text-primary fw-bold mx-auto">Search for doctors</h5>
          <button type="button" className="btn-close" onClick={onClose}></button>
        </div>

        {/* Location Input */}
        <div className="input-group mb-2 border rounded">
          <span className="input-group-text bg-white border-0 text-warning">
            <i className="bi bi-geo-alt"></i>
          </span>
          <input
            type="text"
            className="form-control border-0 shadow-none"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
          />
          <button className="btn text-primary fw-bold" type="button" style={{ backgroundColor: '#f0f4ff' }}>
            <i className="bi bi-crosshair me-1"></i> Detect
          </button>
        </div>

        {/* Search Input */}
        <form onSubmit={handleSearchSubmit}>
          <div className="input-group mb-3 border rounded">
            <span className="input-group-text bg-white border-0 text-muted">
              <i className="bi bi-search"></i>
            </span>
            <input
              type="text"
              className="form-control border-0 shadow-none"
              placeholder="Search for doctors, hospitals, specialties..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              autoFocus
            />
          </div>
        </form>

        {/* Dynamic Suggestions List */}
        <div className="suggestions-list">
          {filteredSpecialties.map((item, index) => (
            <div
              key={index}
              className="suggestion-item d-flex justify-content-between align-items-center p-2 border-bottom"
              onClick={() => handleSelectSpecialty(item)}
              style={{ cursor: 'pointer' }}
            >
              <div className="d-flex align-items-center">
                <i className="bi bi-search text-muted me-3"></i>
                {/* Display the specialty name from DB */}
                <span>{item}</span>
              </div>
              <span className="text-muted small">Specialty</span>
            </div>
          ))}

          {/* Show "Search for..." if typing something new */}
          {searchTerm && (
            <div
              className="suggestion-item d-flex justify-content-between align-items-center p-2"
              onClick={handleSearchSubmit}
              style={{ cursor: 'pointer' }}
            >
              <div className="d-flex align-items-center">
                <i className="bi bi-search text-primary me-3"></i>
                <span className="text-primary">Search for "{searchTerm}"</span>
              </div>
            </div>
          )}
        </div>

      </div>
    </div>
  );
};

export default SearchModal;